import { useState } from "react";
import { toast } from 'react-toastify';
import UploadView from "./view";
import { getFileContent, getSheetData, mapFileContent } from 'utils';
import { noop } from "shared/constants";

const defaultState = {
  selectedFile: null,
  showUploadConfirm: false,
  errorModal: {},
};

const SHEET_HEADERS = {
  name: 'Name',
  siteName: 'Site Name',
  street: 'Street',
  street2: 'Street 2 (Apt./Unt.)',
  city: 'City',
  state: 'State',
  zip: 'Zip',
  country: 'Country',
};

const Upload = ({
  isSyncing = false,
  syncingProgress = 0,
  syncErrors = [],
  isSyncCompleted= false,
  handleSync = noop,
  onContinue = noop,
}) => {
  const [state, setState] = useState(defaultState);

  const validateFile = (sheetData = {}) => {
    let isFileCorrect = true;
    Object.keys(SHEET_HEADERS).map(key => {
      if (!(sheetData[0] || []).includes(SHEET_HEADERS[key])) {
        isFileCorrect = false;
      }
    });
    return isFileCorrect;
  };

  const handleFileUpload = async (selectedFile) => {
    const fileContent = await getFileContent(selectedFile, { header: 1 });
    const sheetData = getSheetData(fileContent, fileContent.SheetNames[0]);

    const dataBeingUploaded = mapFileContent(sheetData);
    const isValidFile = validateFile(sheetData);

    if (!dataBeingUploaded.length || !fileContent || Object.keys(fileContent).length === 0 || !isValidFile || ((dataBeingUploaded || []).length === 1 && Object.values(dataBeingUploaded[0] || {}).every(value => !value)) ) {
      setState(prevState => ({
        ...prevState,
        errorModal: {
          open: true,
          errorMessage: 'Invalid File',
          errorBody: [
            !isValidFile ? 'File content is invalid' : 'Selected file is empty',
          ],
        },
      }));
      return;
    }

    const modifiedData = dataBeingUploaded.map(item => ({
      name: item[SHEET_HEADERS.name],
      site: {
        name: item[SHEET_HEADERS.siteName]
      },
      address: {
        street: item[SHEET_HEADERS.street],
        street2: item[SHEET_HEADERS.street2],
        city: item[SHEET_HEADERS.city],
        state: item[SHEET_HEADERS.state],
        country: item[SHEET_HEADERS.country],
        zip: item[SHEET_HEADERS.zip],
      }
    }));
    handleSync(modifiedData);
  };

  const handleFileChanges = evt => {
    let selectedFile = null;
    if (evt.currentTarget.files && evt.currentTarget.files.length > 0) {
      selectedFile = evt.currentTarget.files[0];
    }
    if (!evt.currentTarget.files && evt.currentTarget.files.length === 0) {
     toast.error('Selected file is empty');
      selectedFile = null;
    }
    setState(prevState => ({
      ...prevState,
      selectedFile,
    }));
    selectedFile && handleFileUpload(selectedFile);
  };

  return (
    <UploadView
      isSyncCompleted={isSyncCompleted}
      isSyncing={isSyncing}
      syncingProgress={syncingProgress}
      syncErrors={syncErrors}
      errorModal={state.errorModal}
      handleFileChanges={handleFileChanges}
      handleUploadClick={() => {
        setState(prevState => ({
          ...prevState,
          showUploadConfirm: true,
        }))
      }}
      handleErrorModalClose={() => {
        setState(prevState => ({
          ...prevState,
          ...prevState,
          errorModal: {},
          selectedFile: null,
        }))
      }}
      onContinue={onContinue}
    />
  )
};

export default Upload;